module.exports = __webpack_public_path__ + "images/illustrations/dashboard.svg";